class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    const goToCheckoutReducedBtns = document.querySelectorAll(
      ".cartDiscountCodeButton"
    );
    if (goToCheckoutReducedBtns) {
      goToCheckoutReducedBtns.forEach((goToCheckoutReducedBtn) => {
        goToCheckoutReducedBtn.addEventListener("click", () => {
          this.handlePromoCode(goToCheckoutReducedBtn);
        });
      });
    }

    const protectionUpsellButton = document.querySelector(
      ".button__drawer--protection"
    );
    if (
      protectionUpsellButton &&
      protectionUpsellButton.classList.contains("active")
    )
      protectionUpsellButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.updateQuantity(protectionUpsellButton.dataset.index, 0);
      });

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    // === CART LIMIT ENFORCEMENT FOR QUANTITY CHANGES ===
    const settings = typeof getCartLimitSettings === 'function' ? getCartLimitSettings() : { enable: false };
    if (settings.enable && typeof isCartLimitReached === 'function') {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cartData => {
          const lineIndex = parseInt(event.target.dataset.index) - 1;
          const currentQty = cartData.items && cartData.items[lineIndex] ? cartData.items[lineIndex].quantity : 0;
          const newQty = parseInt(event.target.value);
          
          // Check count-based limit
          if (settings.type === 'count') {
            const totalQty = (cartData.items || []).reduce((sum, item, idx) => sum + (idx === lineIndex ? newQty : item.quantity || 0), 0);
            const over = totalQty > settings.count;
            if (over) {
              let msg = typeof getCartLimitMessage === 'function' ? getCartLimitMessage(settings) : 'Cart limit reached.';
              showCartLimitErrorBannerAtCartBottom(msg);
              event.target.value = currentQty;
              return;
            }
          }
          
          // Check amount-based limit
          if (settings.type === 'amount') {
            const currentItem = cartData.items && cartData.items[lineIndex];
            if (currentItem) {
              const currentItemTotal = currentItem.price * currentItem.quantity;
              const newItemTotal = currentItem.price * newQty;
              const otherItemsTotal = (cartData.items || []).reduce((sum, item, idx) => {
                if (idx === lineIndex) return sum;
                return sum + (item.price * item.quantity);
              }, 0);
              const newCartTotal = otherItemsTotal + newItemTotal;
              const over = (newCartTotal / 100) > settings.amount;
              
              if (over) {
                let msg = typeof getCartLimitMessage === 'function' ? getCartLimitMessage(settings) : 'Cart limit reached.';
                showCartLimitErrorBannerAtCartBottom(msg);
                event.target.value = currentQty;
                return;
              }
            }
          }
          
          this.updateQuantity(
            event.target.dataset.index,
            event.target.value,
            document.activeElement.getAttribute("name")
          );
        });
    } else {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name")
      );
    }
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
        fetchAndCheckCartLimit(); // Ensure UI is updated after cart update event
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");

        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        if (document.querySelector(".drawer__module--timer")) {
          const timer = document.querySelector(".drawer__module--timer-time");
          const timerDrawerModule = document.querySelector(
            ".drawer__module--timer"
          );
          let time;

          if (localStorage.getItem("storyThemeDrawerTimer")) {
            time = localStorage.getItem("storyThemeDrawerTimer");
          } else {
            time = timerDrawerModule.dataset.duration * 60;
            localStorage.setItem("storyThemeDrawerTimer", time);
          }

          const tick = () => {
            const minutes = Math.floor(time / 60);
            const seconds = time % 60;
            timer.textContent = `${minutes}:${seconds
              .toString()
              .padStart(2, "0")}`;

            if (time > 0) {
              localStorage.setItem("storyThemeDrawerTimer", time--);
            } else {
              const xhr = new XMLHttpRequest();
              xhr.open("POST", "/cart/clear.js", true);
              xhr.setRequestHeader("Content-Type", "application/json");
              xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                  localStorage.removeItem("storyThemeDrawerTimer");
                  window.location.reload();
                }
              };
              xhr.send();
            }
          };

          tick();
          setInterval(() => {
            tick();
          }, 1000);
        }

        const shippingBars = document.querySelectorAll(
          ".drawer__module--free_shipping"
        );
        if (shippingBars) {
          shippingBars.forEach((shippingBar) => {
            const before = shippingBar.querySelector(
              ".free-shipping__left-amount"
            );
            const after = shippingBar.querySelector(".free-shipping__success");
            const amount = shippingBar.querySelector(".free-shipping__amount");
            const drag = shippingBar.querySelector(".free-shipping__drag");
            const current = parsedState.total_price / 100;
            const target = shippingBar.dataset.target;
            const formattedAmount = new Intl.NumberFormat(
              document.body.dataset.shopLocale,
              {
                style: "currency",
                currency: document.body.dataset.shopCurrency,
              }
            ).format(target - current);

            if (target - current > 0) {
              amount.textContent = formattedAmount;
              before.classList.remove("hidden");
              after.classList.add("hidden");
              drag.style.width = `${(current * 100) / target}%`;
            } else {
              after.classList.remove("hidden");
              before.classList.add("hidden");
              drag.style.width = "100%";
            }
          });
        }

        if (document.querySelector("#drawer-trust__swiper")) {
          const trustDrawerCartSlider = new Swiper("#drawer-trust__swiper", {
            autoplay: { delay: 1000 },
            loop: true,
            navigation: {
              nextEl: ".button-next-drawer-trust__swiper",
              prevEl: ".button-prev-drawer-trust__swiper",
            },
          });
        }

        if (document.querySelector("#drawer-upsell__swiper")) {
          const upsellDrawerCartSlider = new Swiper("#drawer-upsell__swiper", {
            slidesPerView: 1.3,
            spaceBetween: 15,
            autoHeight: true,
          });
        }

        function updateCartTotals() {
          // Effectuer une requête AJAX pour obtenir les informations du panier
          fetch("/cart.js")
            .then(function (response) {
              return response.json();
            })
            .then(function (cartData) {
              let totalCompareAtPrice = 0;
              let totalSavings = 0;
              let indexItems = 1;

              cartData.items.forEach(function (item) {
                const varID = item.variant_id; // needed to find right variant from ajax results
                let itemCompareAtPrice = 0;

                const xhr = new XMLHttpRequest();
                xhr.open("GET", "/products/" + item.handle + ".js", false);
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.onreadystatechange = function () {
                  if (xhr.readyState === 4 && xhr.status === 200) {
                    const product = JSON.parse(xhr.responseText);
                    product.variants.forEach(function (variant) {
                      if (
                        variant.id == varID &&
                        variant.compare_at_price !== 0
                      ) {
                        itemCompareAtPrice = variant.compare_at_price;
                        return false;
                      }
                    });
                  }
                };
                xhr.send();

                const itemPrice = item.original_line_price / item.quantity; //price of item
                let itemTotalCompareAtPrice = "";
                const priceDrawerItemContainer = document.querySelector(
                  `.priceWrapper${indexItems}`
                );
                const linePriceDrawerItemContainer = document.querySelector(
                  `.linePriceWrapper${indexItems}`
                );
                indexItems++;
                const itemCompareAtPriceFormatted = new Intl.NumberFormat(
                  document.body.dataset.shopLocale,
                  {
                    style: "currency",
                    currency: document.body.dataset.shopCurrency,
                  }
                ).format(itemCompareAtPrice / 100);
                const itemPriceFormatted = new Intl.NumberFormat(
                  document.body.dataset.shopLocale,
                  {
                    style: "currency",
                    currency: document.body.dataset.shopCurrency,
                  }
                ).format(itemPrice / 100);
                const lineItemCompareAtPriceFormatted = new Intl.NumberFormat(
                  document.body.dataset.shopLocale,
                  {
                    style: "currency",
                    currency: document.body.dataset.shopCurrency,
                  }
                ).format((itemCompareAtPrice * item.quantity) / 100);
                const lineItemPriceFormatted = new Intl.NumberFormat(
                  document.body.dataset.shopLocale,
                  {
                    style: "currency",
                    currency: document.body.dataset.shopCurrency,
                  }
                ).format((itemPrice * item.quantity) / 100);

                const itemOnSaleHTML = `
                  <div class="cart-item__discounted-prices">
                    <span class="visually-hidden">${priceDrawerItemContainer.dataset.salePrice}</span>
                    <s class="cart-item__old-price product-option">${itemCompareAtPriceFormatted}</s>
                    <span class="visually-hidden">${priceDrawerItemContainer.dataset.regularPrice}</span>
                    <strong class="cart-item__final-price product-option">${itemPriceFormatted}</strong>
                  </div>
                `;
                const itemRegularHTML = `<span class="product-option">${itemPriceFormatted}</span>`;

                const lineItemOnSaleHTML = `
                  <div class="cart-item__discounted-prices">
                    <span class="visually-hidden">${priceDrawerItemContainer.dataset.salePrice}</span>
                    <s class="cart-item__old-price product-option">${lineItemCompareAtPriceFormatted}</s>
                    <span class="visually-hidden">${priceDrawerItemContainer.dataset.regularPrice}</span>
                    <strong class="cart-item__final-price product-option">${lineItemPriceFormatted}</strong>
                  </div>
                `;
                const lineItemRegularHTML = `<span class="product-option">${lineItemPriceFormatted}</span>`;

                if (itemCompareAtPrice == null || itemCompareAtPrice < 1) {
                  totalCompareAtPrice +=
                    itemPrice + item.line_level_total_discount;
                  totalSavings += item.line_level_total_discount;
                  itemCompareAtPrice = 0;
                  if (item.original_price <= item.final_price) {
                    priceDrawerItemContainer.innerHTML = itemRegularHTML;
                    linePriceDrawerItemContainer.innerHTML =
                      lineItemRegularHTML;
                  }
                } else {
                  if (itemCompareAtPrice > itemPrice) {
                    itemTotalCompareAtPrice =
                      item.quantity * itemCompareAtPrice;
                    totalCompareAtPrice +=
                      itemTotalCompareAtPrice + item.line_level_total_discount;
                    totalSavings +=
                      itemTotalCompareAtPrice -
                      item.original_line_price +
                      item.line_level_total_discount;
                    if (item.original_price <= item.final_price) {
                      priceDrawerItemContainer.innerHTML = itemOnSaleHTML;
                      linePriceDrawerItemContainer.innerHTML =
                        lineItemOnSaleHTML;
                    }
                  } else {
                    totalCompareAtPrice +=
                      itemPrice + item.line_level_total_discount;
                    if (item.original_price <= item.final_price) {
                      priceDrawerItemContainer.innerHTML = itemRegularHTML;
                      linePriceDrawerItemContainer.innerHTML =
                        lineItemRegularHTML;
                    }
                  }
                }
              });

              const formattedSubtotalAmount = new Intl.NumberFormat(
                document.body.dataset.shopLocale,
                {
                  style: "currency",
                  currency: document.body.dataset.shopCurrency,
                }
              ).format((cartData.total_price + totalSavings) / 100);

              const formattedSavingsAmount = new Intl.NumberFormat(
                document.body.dataset.shopLocale,
                {
                  style: "currency",
                  currency: document.body.dataset.shopCurrency,
                }
              ).format(totalSavings / 100);

              const formattedTotalAmount = new Intl.NumberFormat(
                document.body.dataset.shopLocale,
                {
                  style: "currency",
                  currency: document.body.dataset.shopCurrency,
                }
              ).format(cartData.total_price / 100);

              const subTotalEl = document.querySelector(
                ".drawer__subtotal--amount"
              );
              const savingsEl = document.querySelector(
                ".drawer__savings--amount"
              );
              const totalEl = document.querySelector(".drawer__total--amount");

              if (subTotalEl) {
                if (totalSavings > 0) {
                  subTotalEl.textContent = formattedSubtotalAmount;
                  document.querySelector(".totals.subtotal").style.display =
                    "flex";
                } else {
                  document.querySelector(".totals.subtotal").style.display =
                    "none";
                  document.querySelector(
                    ".totals.subtotal + *"
                  ).style.marginTop = "0";
                }
              }

              if (savingsEl) {
                if (totalSavings > 0) {
                  savingsEl.textContent = "-" + formattedSavingsAmount;
                  document.querySelector(".totals.savings").style.display =
                    "flex";
                } else {
                  document.querySelector(".totals.savings").style.display =
                    "none";
                  document.querySelector(
                    ".totals.savings + *"
                  ).style.marginTop = "0";
                }
              }

              if (totalEl) totalEl.textContent = formattedTotalAmount;
            });
        }

        // Appeler la fonction de mise à jour lors du chargement initial de la page
        updateCartTotals();

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch((e) => {
        console.error(e);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        fetchAndCheckCartLimit(); // Keep cart limit UI in sync after update
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  handlePromoCode(el) {
    const theDiscount = document.getElementById(el.dataset.input).value;
    const toRedirect = `/checkout?discount=${theDiscount}`;
    window.location.href = toRedirect;
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// === CART LIMIT LOGIC START ===
function getCartLimitSettings() {
  const defaults = {
    enable: false,
    type: 'count',
    count: 3,
    amount: 200,
    message_count: 'You can only have [limit] items in your cart at a time.',
    message_amount: 'Your cart total cannot exceed [limit].'
  };
  let settings = defaults;
  if (window.cartLimitSettings) {
    settings = Object.assign({}, defaults, window.cartLimitSettings);
  }
  console.log('[CartLimit] Settings:', settings);
  return settings;
}

function getCartLimitMessage(settings) {
  const msg = settings.type === 'amount'
    ? settings.message_amount.replace('[limit]', settings.amount)
    : settings.message_count.replace('[limit]', settings.count);
  console.log('[CartLimit] Message:', msg);
  return msg;
}

function isCartLimitReached(cartData, settings) {
  if (!settings.enable) {
    console.log('[CartLimit] Limit not enabled');
    return false;
  }
  if (settings.type === 'amount') {
    const over = (cartData.total_price / 100) > settings.amount;
    console.log('[CartLimit] Type: amount, Cart total:', cartData.total_price / 100, 'Limit:', settings.amount, 'Over:', over);
    return over;
  } else {
    // Sum total quantity of all items
    const totalQty = (cartData.items || []).reduce((sum, item) => sum + (item.quantity || 0), 0);
    const over = totalQty >= settings.count;
    console.log('[CartLimit] Type: count, Cart total quantity:', totalQty, 'Limit:', settings.count, 'Over:', over);
    return over;
  }
}



function setAddToCartButtonsDisabled(disabled) {
  document.querySelectorAll('.add-to-cart-btn, [type="submit"][name="add"], #product-pack-submit, .bundle-form [type="submit"]').forEach(btn => {
    btn.disabled = disabled;
    if (disabled) {
      btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.removeAttribute('aria-disabled');
    }
  });
  console.log('[CartLimit] Add to cart buttons', disabled ? 'disabled' : 'enabled');
}

function checkCartLimitAndUpdateUI(cartData) {
  const settings = getCartLimitSettings();
  console.log('[CartLimit] Cart data:', cartData);
  if (!settings.enable) {
    setAddToCartButtonsDisabled(false);
    // Remove any existing error banner
    const oldBanner = document.querySelector('.cart-limit-error-banner-global');
    if (oldBanner) oldBanner.remove();
    console.log('[CartLimit] Limit not enabled, UI reset');
    return;
  }
  if (isCartLimitReached(cartData, settings)) {
    setAddToCartButtonsDisabled(true);
    // Show error banner with appropriate message
    const message = typeof getCartLimitMessage === 'function' ? getCartLimitMessage(settings) : 'Cart limit reached.';
    showCartLimitErrorBannerAtCartBottom(message);
    console.log('[CartLimit] Limit reached, UI updated');
  } else {
    setAddToCartButtonsDisabled(false);
    // Remove any existing error banner
    const oldBanner = document.querySelector('.cart-limit-error-banner-global');
    if (oldBanner) oldBanner.remove();
    console.log('[CartLimit] Limit not reached, UI updated');
  }
}

// Call this after any cart update
function fetchAndCheckCartLimit() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cartData => {
      console.log('[CartLimit] fetchAndCheckCartLimit cartData:', cartData);
      checkCartLimitAndUpdateUI(cartData);
    });
}

// Initialize cart limit display when page loads
document.addEventListener('DOMContentLoaded', () => {
  if (typeof fetchAndCheckCartLimit === 'function') {
    fetchAndCheckCartLimit();
  }
});

// Function to suggest items to remove to get under cart limit
function suggestItemsToRemove() {
  const settings = getCartLimitSettings();
  if (!settings.enable || settings.type !== 'amount') return;
  
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cartData => {
      const currentTotal = cartData.total_price / 100;
      if (currentTotal <= settings.amount) return null;
      
      const overAmount = currentTotal - settings.amount;
      const items = [...cartData.items].sort((a, b) => (b.price * b.quantity) - (a.price * a.quantity));
      
      let suggestions = [];
      let totalToRemove = 0;
      
      for (const item of items) {
        const itemTotal = (item.price * item.quantity) / 100;
        if (totalToRemove < overAmount) {
          suggestions.push({
            id: item.id,
            title: item.title,
            price: item.price / 100,
            quantity: item.quantity,
            total: itemTotal,
            removeQuantity: Math.min(item.quantity, Math.ceil((overAmount - totalToRemove) / (item.price / 100)))
          });
          totalToRemove += itemTotal;
        }
      }
      
      return {
        overAmount: overAmount,
        suggestions: suggestions.slice(0, 3) // Limit to 3 suggestions
      };
    });
}


// === CART LIMIT LOGIC END ===

// Function to check if adding an item would exceed the cart limit
function wouldExceedCartLimit(variantId, quantity = 1) {
  const settings = getCartLimitSettings();
  if (!settings.enable) return Promise.resolve(false);
  
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cartData => {
      if (settings.type === 'amount') {
        // For amount-based limits, we need to get the variant price
        // We'll use the variant ID to find the price from the product form or estimate it
        const variantPriceElement = document.querySelector(`input[name="id"][value="${variantId}"]`)?.closest('form')?.querySelector('.price-item--regular, .price-item--sale, .price__regular .price-item, .price__sale .price-item');
        let variantPrice = 0;
        
        if (variantPriceElement) {
          const priceText = variantPriceElement.textContent || variantPriceElement.innerText;
          variantPrice = parseFloat(priceText.replace(/[^0-9.,]/g, '').replace(',', '.')) || 0;
        }
        
        // If we can't get the price from the DOM, we'll estimate based on current cart items
        if (variantPrice === 0) {
          // Fallback: estimate price based on average item price in cart
          const avgPrice = cartData.items.length > 0 
            ? (cartData.items.reduce((sum, item) => sum + (item.price / 100), 0) / cartData.items.length)
            : 20; // Default estimate of 20€ if no items in cart
          variantPrice = avgPrice;
        }
        
        const currentTotal = cartData.total_price / 100;
        const newItemTotal = variantPrice * quantity;
        const wouldExceed = (currentTotal + newItemTotal) > settings.amount;
        console.log('[CartLimit] Would exceed amount limit:', wouldExceed, 'Current:', currentTotal, 'New item:', newItemTotal, 'Limit:', settings.amount);
        return wouldExceed;
      } else {
        // For count-based limits
        const currentQty = (cartData.items || []).reduce((sum, item) => sum + (item.quantity || 0), 0);
        const wouldExceed = (currentQty + quantity) > settings.count;
        console.log('[CartLimit] Would exceed count limit:', wouldExceed, 'Current:', currentQty, 'New quantity:', quantity, 'Limit:', settings.count);
        return wouldExceed;
      }
    })
    .catch(error => {
      console.error('[CartLimit] Error checking cart limit:', error);
      return false; // If there's an error, allow the addition
    });
}

// Function to check if adding an item would exceed the cart limit (synchronous version for immediate validation)
function wouldExceedCartLimitSync(itemId, quantity = 1) {
  const settings = getCartLimitSettings();
  if (!settings.enable) return false;
  
  // This is a synchronous check that uses the current cart data
  // It's less accurate but provides immediate feedback
  if (settings.type === 'amount') {
    // For amount-based limits, we need to estimate the price
    // This is a fallback when we can't fetch the product price immediately
    const currentTotal = parseFloat(document.querySelector('[data-cart-total]')?.textContent?.replace(/[^0-9.,]/g, '').replace(',', '.') || '0');
    const estimatedItemPrice = parseFloat(document.querySelector(`[data-product-price="${itemId}"]`)?.textContent?.replace(/[^0-9.,]/g, '').replace(',', '.') || '0');
    const newItemTotal = estimatedItemPrice * quantity;
    const wouldExceed = (currentTotal + newItemTotal) > settings.amount;
    console.log('[CartLimit] Sync check - Would exceed amount limit:', wouldExceed, 'Current:', currentTotal, 'New item:', newItemTotal, 'Limit:', settings.amount);
    return wouldExceed;
  } else {
    // For count-based limits
    const currentQty = parseInt(document.querySelector('[data-cart-count]')?.textContent || '0');
    const wouldExceed = (currentQty + quantity) > settings.count;
    console.log('[CartLimit] Sync check - Would exceed count limit:', wouldExceed, 'Current:', currentQty, 'New quantity:', quantity, 'Limit:', settings.count);
    return wouldExceed;
  }
}



// Function to clear all cart limit banners
function clearCartLimitBanners() {
  const banners = document.querySelectorAll('.cart-limit-error-banner-global');
  banners.forEach(banner => banner.remove());
}





function showCartLimitErrorBannerAtCartBottom(message) {
  // Try to find the cart summary area
  let summary = document.querySelector('.cart__footer, .drawer__footer, .cart-summary, .drawer__totals, .totals, .cart__totals, .drawer__summary, .cart-summary__footer');
  if (!summary) {
    // Fallback: try to find the first element with subtotal or total
    summary = document.querySelector('[class*="subtotal"], [class*="totals"], [class*="summary"]');
  }
  if (!summary) return;
  // Remove any existing error banner
  let oldBanner = summary.parentElement.querySelector('.cart-limit-error-banner-global');
  if (oldBanner) oldBanner.remove();
  
  // Create the banner first
  const banner = document.createElement('div');
  banner.className = 'cart-limit-error-banner-global';
  banner.setAttribute('role', 'alert');
  banner.setAttribute('aria-live', 'assertive');
  banner.innerHTML = `
    <span style="display:flex;align-items:center;gap:0.5em;justify-content:center;">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><circle cx="12" cy="16" r="1"/></svg>
      <span style="color:#666;">${message}</span>
    </span>
  `;
  
  // Add suggestions if available
  if (typeof suggestItemsToRemove === 'function') {
    suggestItemsToRemove().then(suggestions => {
      if (suggestions && suggestions.suggestions.length > 0) {
        const suggestionsDiv = document.createElement('div');
        suggestionsDiv.style.marginTop = '0.5em';
        suggestionsDiv.style.fontSize = '0.85em';
        suggestionsDiv.style.color = '#666';
        
        let suggestionsText = '<strong>Suggestion :</strong> Réduisez la quantité de :<br>';
        suggestions.suggestions.forEach(item => {
          suggestionsText += `• ${item.title} (${item.removeQuantity} article${item.removeQuantity > 1 ? 's' : ''})<br>`;
        });
        
        suggestionsDiv.innerHTML = suggestionsText;
        banner.appendChild(suggestionsDiv);
      }
    });
  }
  banner.style.background = '#f8f8f8';
  banner.style.border = '1px solid #e0e0e0';
  banner.style.borderRadius = '4px';
  banner.style.padding = '0.5em 1em';
  banner.style.margin = '0 0 0.75em 0';
  banner.style.boxShadow = 'none';
  banner.style.fontSize = '0.9em';
  banner.style.fontWeight = '400';
  banner.style.textAlign = 'center';
  banner.style.maxWidth = '350px';
  banner.style.marginLeft = 'auto';
  banner.style.marginRight = 'auto';
  // Insert above the summary
  summary.parentElement.insertBefore(banner, summary);
  // Fade out after 6s
  banner.style.opacity = '1';
  banner.style.transition = 'opacity 0.3s';
  setTimeout(() => {
    banner.style.opacity = '0';
    setTimeout(() => banner.remove(), 300);
  }, 6000);
}
